import { createApplicationState } from '../applicationState';
import { renderApplication } from '../renderApplication';
import { init as initAuthContext } from 'shared/services/authenticationWidget/authContext';
import { init as initEvents } from 'shared/services/authenticationWidget/events';

import { createContext } from './createContext';

export function runApp(): void {
  const context = createContext();

  const store = createApplicationState(context);

  initAuthContext(context, store);
  initEvents(context, store);

  renderApplication({ context, store });
}
